import { SectionTitle, InfoItem } from "@/components/molecules";

export const GeneralDetailsSection = ({ generalDetails }) => {
  const getVal = (v) => v !== undefined && v !== null ? v : '-';

  return (
    <>
      {/* General Details Section */}
      <div className="order-overview">
        <div className="sc-border grid  pl-4">
          <SectionTitle id="general_details" label="General Details" />
        </div>
        <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
          <InfoItem label="Product" value={getVal(generalDetails?.item)} isHighlighted={true} />
          <InfoItem
            label="Source Online Line ID"
            value={getVal(generalDetails?.sourceOnlineLineId)}
          />
          <InfoItem
            label="Material UOM"
            value={getVal(generalDetails?.materialUom)}
          />
          <InfoItem label="Sale UOM" value={getVal(generalDetails?.saleUom)} />
          <InfoItem label="Base UOM" value={getVal(generalDetails?.baseUom)} />
          <InfoItem
            label="Alternative Order Line Number"
            value={getVal(generalDetails?.alternativeOrderLineNumber)}
          />
          <InfoItem
            label="Item Category ID"
            value={getVal(generalDetails?.itemCategoryId)}
          />
          <InfoItem
            label="Item Category Type"
            value={getVal(generalDetails?.itemCategoryType)}
          />
          <InfoItem
            label="Conversion Multiplier To Base"
            value={getVal(generalDetails?.conversionMultiplierToBase)}
          />
        </div>
      </div>
    </>
  );
};
